import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar, DayCalendarSkeleton } from '@mui/x-date-pickers';
import 'dayjs/locale/cs';
import { MoonSunAvailabilityIcons } from './MoonSunAvailabilityIcons';
import Stack from '@mui/material/Stack';

interface CalendarWithAvailabilityProps {
  value?: Date | Dayjs | null;
  referenceDate?: Date | Dayjs;
  isLoading: boolean;
  highlightedDays: Record<string, 'morning' | 'afternoon' | 'both' | null>;
  onMonthChange: (month: Dayjs) => void;
  onChange: (newDate: Dayjs | null) => void;
  minDate?: Dayjs;
}

export const CalendarWithAvailability = ({
  value,
  referenceDate,
  isLoading,
  highlightedDays,
  onMonthChange,
  onChange,
  minDate,
}: CalendarWithAvailabilityProps) => {
  return (
    <Stack>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="cs">
        <DateCalendar
          value={value ? dayjs(value) : null}
          referenceDate={referenceDate ? dayjs(referenceDate) : undefined}
          loading={isLoading}
          onMonthChange={onMonthChange}
          onChange={onChange}
          minDate={minDate}
          renderLoading={() => <DayCalendarSkeleton />}
          slots={{
            day: MoonSunAvailabilityIcons,
          }}
          slotProps={{
            day: {
              highlightedDays,
            } as Record<string, unknown>,
          }}
        />
      </LocalizationProvider>
    </Stack>
  );
};
